// extracted by mini-css-extract-plugin
export default {"reaction":"EXhqBz","android":"lIfwOo"};